// Eventos que o fluxo da Meta avisa ao modo de gravação do App Review
// (ReviewModeCaptions), para a legenda/narração avançar sozinha nos passos que
// acontecem dentro da janela da Meta, onde a tecla F9 não chega ao SinTicket.
export type ReviewEvent = 'meta-popup-opened' | 'meta-code-received';

export const REVIEW_EVENT_NAME = 'sinticket:review-event';

export const emitReviewEvent = (event: ReviewEvent) => {
  window.dispatchEvent(new CustomEvent<ReviewEvent>(REVIEW_EVENT_NAME, { detail: event }));
};
